import { useParamsSearch } from '@anytag/shared-hooks';
import { AutoManagedJoinedInfluencersSearchSchemaType } from '../schemaTypes';

export const useAutoManagedJoinedInfluencersFilter = () =>
  useParamsSearch<AutoManagedJoinedInfluencersSearchSchemaType>();
